import Range from './dateRangeUtil'

const START_YEAR = 2018

let currentDate = new Date()
var endYear = currentDate.getFullYear() + 10

const END_YEAR = endYear

const UNIT_YEAR = '年'
const UNIT_MONTH = '月'
const UNIT_DAY = '日'

function isLeapYear (y) {
  return (y % 4 == 0) && (y % 100 != 0|| y % 400 == 0)
};

function getDays (y, m) {
  y = Number(y)
  m = Number(m)
  var endDay = 30
  switch (m) {
    case 2:
      endDay = isLeapYear(y) ? 29 : 28; break
    case 1:
    case 3:
    case 5:
    case 7:
    case 8:
    case 10:
    case 12:
      endDay = 31; break
    case 4:
    case 6:
    case 9:
    case 11:
    default:
      endDay = 30; break
  }
  var days = Range(1, endDay, false, UNIT_DAY)
  return days.map((day) => {
    return { value: day }
  })
};

const yearData = Range(START_YEAR, END_YEAR, false, UNIT_YEAR)
const monthData = Range(1, 12, false, UNIT_MONTH)

const dateData = yearData.map((year) => {
  const item = {
    value: year,
    children: []
  }
  monthData.forEach((month) => {
    var days = getDays(year.slice(0, -1), month.slice(0, -1))
    var monthDt = {
      value: month,
      children: days
    }
    item.children.push(monthDt)
  })
  return item
})

const date = new Date()
  const dateAnchor = [
    { value: `${date.getFullYear()}${UNIT_YEAR}` },
    { value: `${date.getMonth() + 1}${UNIT_MONTH}` },
    { value: `${date.getDate()}${UNIT_DAY}` }
  ]

export {
  dateAnchor,
  dateData
}
